import { FC } from "react"
import { useRouter } from "next/router"
// Components
import { MainWrapper } from "./index.styles"
import { Text, VSpace } from "@components/common"
// Libs
import { useTranslation } from "next-i18next"
import useGetEventSetting from "@hooks/useGetEventSetting"
// Styles

interface IProps {}

const PolicyPage: FC<IProps> = (props) => {
  const { t } = useTranslation(["common"])
  const { locale = "en", query } = useRouter()
  const { EventData, SettingData } = useGetEventSetting()

  const showSettingData = query?.from === "footer" || !EventData.loaded

  return (
    <>
      <MainWrapper>
        <Text size="40px" weight="bold" color="blue2">
          {t("POLICY_AND_TERMS_Label_Privacy_Policy")}
        </Text>
        <VSpace length="48px" />
        <div
          dangerouslySetInnerHTML={{
            __html: showSettingData ? SettingData.data.privacy.value[locale] : EventData.data.privacy[locale]
          }}
        />
      </MainWrapper>
    </>
  )
}

export default PolicyPage
